/* 棚内見出し */
import React, { memo } from 'react';
import { convertLine } from '../Convert';

interface Props {
  label: string;
}

const ShelfHeader: React.FC<Props> = ({ label }) => {
  return <div className={'shelf-heading text-center'}>{convertLine(label)}</div>;
};

export default memo(ShelfHeader);
